<template>
  <div class="fab"
       :class="fabClasses"
       @click="$emit('click')">
    <component :is="icon"
               :iconColor="iconColor"
               width="48"
               height="48"
               class="icon" />
  </div>
</template>

<script>
  export default {
    props: {
      icon: {
        type: String,
        required: true
      },

      iconColor: {
        type: String,
        required: false,
        default: '#fff'
      },

      placement: {
        type: String,
        required: false,
        default: 'right'
      }
    },

    computed: {
      fabClasses() {
        return {
          'fab-left': this.placement === 'left',
          'fab-right': this.placement === 'right'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .fab {
    width: 68px;
    height: 68px;

    position: fixed;
    z-index: 999;

    cursor: pointer;
    border-radius: 50%;
    background: map-get($colors, primary);

    display: flex;
    justify-content: center;
    align-items: center;

    &:focus {
      outline: none;
    }

    .icon {
      width: 30px;
      height: 30px;
    }
  }

  .fab-left {
    left: 24px;
    bottom: 24px;
  }

  .fab-right {
    right: 24px;
    bottom: 24px;
  }
</style>
